import { NavigationDto } from '@asset-metrix/portal-gateway-client-js';

export const getNavigationItemBySlug = (
  navItems: NavigationDto['rootNavigationItems'],
  searchSlug: string
): NavigationDto['rootNavigationItems'][number] | undefined => {
  const matchingItem = navItems.find(
    (n) =>
      n.completeSlug === searchSlug ||
      searchSlug.startsWith(`${n.completeSlug}/`)
  );

  if (matchingItem != null) {
    if (matchingItem.completeSlug === searchSlug) {
      return matchingItem;
    } else {
      return matchingItem.type === 'navigation-menu-item'
        ? getNavigationItemBySlug(matchingItem.items, searchSlug)
        : undefined;
    }
  }
};
